import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@mui/styles";
import ListView from "~components/styled/listView/ListView";
import filterItems from "~libs/filterItems";
import { fetchLocalidades } from "./actions";
import localRepository from "../../../localRepository";
import SearcherList, {
  SearcherListChangeEvent,
} from "~styled/searcherList/SearcherList";

const useStyles = makeStyles((theme) => ({
  searcher: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "space-around",
  },
}));

interface LocalidadSelectorProps {
  label: string;
  onSelected?: (event: { target: { value: string } }) => void;
  provinciaId: string | null;
}

interface Localidad {
  label: string;
  value: string;
  provId: string;
  count?: number;
}

interface LocalidadSelectorState {
  localidadSelectorReducer: {
    localidades: Localidad[];
    isLoading: boolean;
  };
}

const useReduxSelector = () =>
  useSelector((state: LocalidadSelectorState) => {
    const localidadSelectorReducer = state.localidadSelectorReducer;

    return {
      localidades: localidadSelectorReducer.localidades,
      isLoading: localidadSelectorReducer.isLoading,
    };
  });

const LocalidadSelector: React.FC<LocalidadSelectorProps> = ({
  label,
  onSelected,
  provinciaId,
}) => {
  const [filter, setFilter] = useState<string>(""); // Filter is a string
  const dispatch = useDispatch();
  const { localidades, isLoading } = useReduxSelector();

  const mostUsedLoc: Localidad[] = localRepository.mostUsedLoc
    .get()
    .filter((loc: Localidad) => loc.provId === provinciaId)
    .sort((x, y) => (y.count || 0) - (x.count || 0))
    .slice(0, 3);

  useEffect(() => {
    if (provinciaId) dispatch(fetchLocalidades(provinciaId));
  }, [dispatch, provinciaId]);

  const handleItemSelected = (item: {
    label: string;
    value: string | null;
  }) => {
    if (onSelected) {
      onSelected({ target: { value: item.value || "" } });
    }
  };

  const handleFilterChange = (event: SearcherListChangeEvent) => {
    setFilter(event.target.value);
  };

  const classes = useStyles();

  return (
    <div className={classes.searcher}>
      <SearcherList
        onClear={() => setFilter("")}
        filter={filter}
        onChange={handleFilterChange}
        placeholder={label}
        borderBottomRounded={undefined}
      />
      <ListView
        isLoading={isLoading}
        onItemSelected={handleItemSelected}
        list={filter === "" ? localidades : filterItems(localidades, filter)}
        mostUsedList={filter === "" ? mostUsedLoc : []}
      />
    </div>
  );
};

export default LocalidadSelector;
